import { ReactNode, useEffect, useState } from 'react';
import { useMaintenanceStatus } from '@/hooks/useMaintenanceStatus';
import MaintenancePage from '@/pages/MaintenancePage';

// Mesmo nome de evento disparado pelo interceptor 503 em `lib/api.ts`.
const MAINTENANCE_EVENT = 'app:maintenance';

/**
 * Bloqueia toda a aplicação do assinante quando o sistema está em manutenção,
 * exibindo a `MaintenancePage`. Combina o status público (polling) com o
 * sinal imediato vindo de respostas 503 das chamadas autenticadas.
 */
export function MaintenanceGate({ children }: Readonly<{ children: ReactNode }>) {
  const { data } = useMaintenanceStatus();
  const [forcedMessage, setForcedMessage] = useState<string | null>(null);

  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<{ message?: string }>).detail;
      setForcedMessage(detail?.message ?? '');
    };
    window.addEventListener(MAINTENANCE_EVENT, handler);
    return () => window.removeEventListener(MAINTENANCE_EVENT, handler);
  }, []);

  // Quando o status público confirma que NÃO há manutenção, limpa o sinal
  // forçado para liberar o app novamente.
  useEffect(() => {
    if (data?.maintenance_mode === false) {
      setForcedMessage(null);
    }
  }, [data]);

  const isMaintenance = Boolean(data?.maintenance_mode) || forcedMessage !== null;

  if (isMaintenance) {
    const message = data?.maintenance_mode ? data.message : forcedMessage || undefined;
    return <MaintenancePage message={message} />;
  }

  return <>{children}</>;
}
